/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ f: NonNullable<unknown> }} Confirm_Delete_FloorInputs */



/**
* | output |
* | --- |
* | "Are you sure you want to delete this floor \"{f}\"?" |
*
* @param {Confirm_Delete_FloorInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const confirm_delete_floor = /** @type {((inputs: Confirm_Delete_FloorInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Confirm_Delete_FloorInputs, { locale?: "fr" | "en" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ (`Are you sure you want to delete this floor "${i?.f}"?`)
	return /** @type {LocalizedString} */ (`Êtes-vous sûr de vouloir supprimer ce niveau “${i?.f}“ ?`)
});